// import axios from 'axios'

const state = {
  details: {
    productCode: '',
    branchCode: '',
    partnerRefNo: '',
    prenameThai: '', // auto
    thaiName: '', // auto
    prenameEng: '', // auto
    engName: '', // auto
    birthday: '', // auto
    age: '', // auto
    nationality: '',
    idcard: '', // auto
    idcardExpireDate: '',
    marriageStatus: '',
    livingStatus: '',
    mobile: '', // auto
    phone: '',
    email: '', // auto
    lineId: '', // auto
    facebook: '', // auto
    documentsReceive: '',
    occupation: '',
    income: '',
    otherIncome: '',
    incomeSource: '',
    otherIncomeSource: '',
    invoiceLocation: '',
    campaign: ' ',
    loanAmt: '', // Auto จากรีเควสตอนแรก
    loanInstallment: '', // Auto จากรีเควสตอนแรก
    accountName: '', // Auto
    bankCode: 'BKK', // Auto
    bankAccountNo: '', // Auto
    currentAddress: {
      building: '', // auto
      address: '', // auto
      roomNo: '', // auto
      moo: '', // auto
      soi: '', // auto
      road: '', // auto
      subDistrictName: '',
      districtName: '',
      provinceName: '',
      zipcode: '',
      textAddress: ''
    },
    office: {
      name: '',
      department: '',
      building: '',
      roomNo: '',
      address: '',
      moo: '',
      soi: '',
      road: '',
      subDistrictName: '',
      districtName: '',
      provinceName: '',
      zipcode: '',
      phone: '',
      businessType: '',
      textAddress: ''
    },
    guarantor: {
      prename: '',
      thaiName: '',
      age: '',
      origin: '',
      nationality: '',
      building: '',
      roomNo: '',
      address: '',
      moo: '',
      soi: '',
      road: '',
      subDistrictName: '',
      districtName: '',
      provinceName: '',
      zipcode: '',
      idcard: '',
      textAddress: ''
    },
    stateSubmit: 0,
    professionalId: null,
    nimcapId: null,
    mergeUrl: null,
    guarantorMergeUrl: null,
    borrowerImage: {
      confirmPDPA: false,
      imageIdCard: null,
      faceWithIdCardImage: null,
      signature: null
    },
    guarantorImage: {
      confirmPDPA: false,
      imageIdCard: null,
      faceWithIdCardImage: null,
      signature: null
    }
  }
}
const actions = {
  SET_EL_VALUE: ({commit}, payload) => {
    commit('SEL_STATE_ALL_EL', payload)
  }
}
const mutations = {
  SEL_STATE_ALL_EL: (state, data) => {
    if (data.hasOwnProperty('sub_key')) {
      state.details[data['main_key']][data['sub_key']] = data['value']
    } else {
      state.details[data['main_key']] = data['value']
    }
  }
}
const getters = {
  GET_DETAILS: state => {
    return state.details
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/nimcap.js